export default {
    mounted(el, binding) {
        const maxBytes = binding.value;

        const getByteLength = (str) => new TextEncoder().encode(str).length;

        const inputHandler = () => {
            let val = el.value;
            let bytes = getByteLength(val);

            if (bytes > maxBytes) {
                while (getByteLength(val) > maxBytes) {
                    val = val.slice(0, -1);
                }
                el.value = val;
                el.dispatchEvent(new Event('input')); // v-model 연동
            }
        };

        el.addEventListener('input', inputHandler);
    },
};
